import React from "react";

export default function CustomizeCTA() {
  
  const handleContactClick = () => {
    // Navigate to contact page or scroll to section
    const contactSection = document.getElementById("contact");
    if (contactSection) {
      contactSection.scrollIntoView({ behavior: "smooth" });
    } else {
      window.location.href = "/contact"; 
    }
  };

  return (
    <section className="cta-section">
      <div className="cta-container">
        
        {/* Decorative Left Icon */}
        <div className="cta-icon-box">
          <span className="cta-needle">🧵</span>
        </div>

        <div className="cta-content">
          <h2 className="cta-heading">Want to <span className="cta-highlight">customize</span> your product?</h2>
          <p className="cta-subtext">
            Have a unique vision? We specialize in bringing your personal stories to life through thread.
          </p>
        </div>

        <div className="cta-action">
          <button className="cta-btn" onClick={handleContactClick}>
            <span>Contact Us</span>
            <div className="cta-btn-border"></div>
          </button>
        </div>

      </div>
    </section>
  );
}